export enum Currency {
  PPP_USD_2017 = 'PPP_USD_2017',
  REAL = 'REAL',
}
